module.exports = __webpack_public_path__ + "static/media/115-hungary.8061e6ff.svg";